import axios from 'axios'
import store from '../store'
import {
  Indicator
} from 'mint-ui';

let flag = 0;
const CancelToken = axios.CancelToken;
const source = CancelToken.source();
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 15000,
  cancelToken: source.token
})


service.interceptors.request.use(function (config) {
  flag++;
  Indicator.open({
    text: '加载中...',
    spinnerType: 'fading-circle'
  });
  return config;
}, function (error) {
  return Promise.reject(error);
});


service.interceptors.response.use(function (response) {
  flag--;
  if (!flag) {
    Indicator.close();
  }
  if (!response.data.success && response.data.data == "ErrorToLogin") {
    store.dispatch("LogOut");
  }
  return response;
}, function (error) {
  flag--;
  Indicator.close();
  return Promise.reject(error);
});
export default service